import { faPen } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Colors } from '@vetahealth/fishing-gear/colors'
import { Button, Dropdown, MenuProps } from 'antd'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { MappingKey } from './helpers'

interface TitleProps {
  mapping?: MappingKey
  mappingLabels: Record<MappingKey, string>
  errorCount?: number
  field: string
  onSelect: (key: MappingKey) => void
  availableMappings: Array<MappingKey>
}

const HeaderLabel = styled.div`
  display: flex;
  flex-direction: row;
  min-width: 160px;
  align-items: center;
  justify-content: space-between;
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const ColumnState = styled.div<{ $hasError?: boolean }>`
  color: ${({ $hasError }) => ($hasError ? Colors.ruby600 : Colors.gray600)};
  font-style: italic;
`

const Strong = styled.div`
  font-weight: bold;
`

const Pale = styled.div`
  color: ${Colors.gray600};
`

export default function TableHead({
  mapping,
  mappingLabels,
  errorCount = 0,
  field,
  availableMappings,
  onSelect,
}: TitleProps): React.ReactNode {
  const { t } = useTranslation()

  const items: MenuProps['items'] = [
    ...availableMappings.map((mappingKey) => ({
      key: mappingKey,
      label: mappingLabels[mappingKey],
    })),
    {
      label: t('widgets.csvImport.ignore'),
      key: '<ignore>',
    },
  ]

  return (
    <HeaderLabel>
      <Wrapper>
        {mapping ? <Strong>{mappingLabels[mapping]}</Strong> : <Pale>{field}</Pale>}
        {mapping ? (
          <ColumnState $hasError={errorCount > 0}>
            {errorCount > 0 ? t('widgets.csvImport.countErrors', { count: errorCount }) : t('actions.ok')}
          </ColumnState>
        ) : (
          <ColumnState>{t('widgets.csvImport.ignored')}</ColumnState>
        )}
      </Wrapper>

      <Dropdown
        trigger={['click']}
        menu={{
          items,
          onClick: (e) => onSelect(e.key as MappingKey),
        }}
      >
        <Button shape="circle" type="text">
          <FontAwesomeIcon icon={faPen} color={Colors.mauve600} />
        </Button>
      </Dropdown>
    </HeaderLabel>
  )
}
